"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _redux = require("redux");

var _nuiShell = require("@concur/nui-shell");

var _listingsModule = _interopRequireDefault(require("../listings/listingsModule"));

var _listingModule = _interopRequireDefault(require("../listing/listingModule"));

var _termsModule = _interopRequireDefault(require("../terms/termsModule"));

var _userProfileModule = _interopRequireDefault(require("../userProfile/userProfileModule"));

var _utilsModule = _interopRequireDefault(require("../utils/utilsModule"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default = (0, _redux.combineReducers)(_objectSpread({
  listings: _listingsModule.default,
  listing: _listingModule.default,
  terms: _termsModule.default,
  userProfile: _userProfileModule.default,
  meta: _utilsModule.default
}, _nuiShell.reducers));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./lib/app/rootReducer.js
// module id = 92
// module chunks = 0